export var FETCH_CONFIGURATION_REQUEST = 'FETCH_CONFIGURATION_REQUEST';
export var FETCH_CONFIGURATION_FAILED = 'FETCH_CONFIGURATION_FAILED';
export var FETCH_CONFIGURATION_SUCCEEDED = 'FETCH_CONFIGURATION_SUCCEEDED';
export var SET_SOCIETY_STEP = 'SET_SOCIETY_STEP';
export var SET_SOCIETY_STAGES = 'SET_SOCIETY_STAGES';
export var SET_SOCIETY_STAGES_FAILED = 'SET_SOCIETY_STAGES_FAILED';
export var FETCH_VALUATION_REQUEST = 'FETCH_VALUATION_REQUEST';
export var FETCH_VALUATION_SUCCEEDED = 'FETCH_VALUATION_SUCCEEDED';
export var FETCH_VALUATION_FAILED = 'FETCH_VALUATION_FAILED';
export var VALIDATE_VALUATION_REQUEST = 'VALIDATE_VALUATION_REQUEST';
export var VALIDATE_VALUATION_SUCCEEDED = 'VALIDATE_VALUATION_SUCCEEDED';
export var VALIDATE_VALUATION_FAILED = 'VALIDATE_VALUATION_FAILED';
export var FETCH_SHOWCASE_PAGE_REQUEST = 'FETCH_SHOWCASE_PAGE_REQUEST';
export var FETCH_SHOWCASE_PAGE_FAILED = 'FETCH_SHOWCASE_PAGE_FAILED';
export var FETCH_SHOWCASE_PAGE_SUCCEEDED = 'FETCH_SHOWCASE_PAGE_SUCCEEDED';
export var VALIDATE_SHOWCASE_REQUEST = 'VALIDATE_SHOWCASE_REQUEST';
export var VALIDATE_SHOWCASE_SUCCEEDED = 'VALIDATE_SHOWCASE_SUCCEEDED';
export var VALIDATE_SHOWCASE_FAILED = 'VALIDATE_SHOWCASE_FAILED';
export var VALIDATE_CONFIGURATION_REQUEST = 'VALIDATE_CONFIGURATION_REQUREST';
export var VALIDATE_CONFIGURATION_FAILED = 'VALIDATE_CONFIGURATION_FAILED';
export var VALIDATE_CONFIGURATION_SUCCEEDED = 'VALIDATE_CONFIGURATION_SUCCEEDED';
export var SET_EMAIL_SENDER = 'SET_EMAIL_SENDER';
